var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-4"},[_c('Message',{attrs:{"payload":_vm.payload,"additional_data":{ resource_type: 'Alert', endpoint: '/alerts/', headers: 'admin_headers' }}})],1),(_vm.offer)?_c('OfferStatus',{attrs:{"payload":_vm.offer,"buttonClass":"offer-status-button"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }